import Base from "../Base";

class Manager extends Base{
	constructor(props: string){
		super(props)
		this.res = {
			'code':300,
			'msg':'网络出错,未获取到数据'
		}
	}
	/**
	 * 获取用户列表
	 * @param data IQuery
	 * @returns 
	 */
	async getList<T>(url:string,data:IMain.IQuery):Promise<IMain.IRes<T>>{
		return await this.HttpPost(url,data)
	}
	/**
	 * 添加用户
	 * @param data IParams
	 * @returns 
	 */
	async add(url:string,data:any):Promise<IMain.IResData<any>>{
		return await this.HttpPost(url+'/add',data)
	}
	/**
	 * 修改用户
	 * @param data
	 * @returns 
	 */
	async edit(url:string,data:any):Promise<IMain.IResData<any>>{
		return await this.HttpPut(url+'/edit',data)
	}
	/**
	 * 删除用户
	 * @param data items 1,2,3,4,5,6
	 * @returns 
	 */
	async del(url:string,data:number[]):Promise<IMain.IResData<any>>{
		return await this.HttpDel(url+'/del',data)
	}
	
	/**
	 * 根据id查询用户信息
	 * @param id iid
	 * @returns 
	 */
	async getInfoById<T>(url:string,id:number):Promise<IMain.IResData<T>>{
		return await this.HttpGet(url+'/getInfoById',{id})
	}

	
	/**
	 * 根据id查询用户信息
	 * @param id iid
	 * @returns 
	 */
	 async getData<T>(url:string,data:any):Promise<IMain.IResData<T>>{
		return await this.HttpGet(url,data)
	}

	//post请求
	/**
	 * post请求
	 * @param data items 1,2,3,4,5,6
	 * @returns 
	 */
	async post(url:string,data:{[key:string]:any}):Promise<IMain.IResData<any>>{
		return await this.HttpPost(url,data)
	}
}

export default Manager;